import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["data-testid"];

var _templateObject;

import React, { forwardRef } from 'react';
import { Select as AntSelect } from 'antd'; // eslint-disable-next-line import/no-extraneous-dependencies

import styled from 'styled-components';
var StyledSelect = styled(AntSelect)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-select-focused:not(.ant-select-disabled) {\n    &.ant-select-single, &.ant-select-multiple {\n      &:not(.ant-select-customize-input) > .ant-select-selector {\n        box-shadow: none;\n        border-color: ", ";\n      }\n    }\n  }\n"])), function (props) {
  return props.theme.colors.primary;
});

var InternalSelect = function InternalSelect(props, ref) {
  var dataTestId = props['data-testid'],
      otherProps = _objectWithoutProperties(props, _excluded);

  var dropdownRender = function dropdownRender(OriginalNode) {
    return dataTestId ? /*#__PURE__*/React.createElement("div", {
      "data-testid": "".concat(dataTestId, "Panel")
    }, OriginalNode) : OriginalNode;
  };

  return /*#__PURE__*/React.createElement(StyledSelect, _extends({
    ref: ref,
    "data-testid": dataTestId,
    dropdownRender: dropdownRender
  }, otherProps));
}; // eslint-disable-next-line max-len
// inspired by antd: https://github.com/ant-design/ant-design/blob/31eef3a956e45a9ad0f75dfe4dd1928a80e8e183/components/select/index.tsx#L204


var Select = /*#__PURE__*/forwardRef(InternalSelect);
Select.OptGroup = AntSelect.OptGroup;
Select.Option = AntSelect.Option;
export default Select;